import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class DepartmentAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'Departments';

  /**
   * Lấy ra danh sách phòng ban dạng phẳng
   * @param {*} payload
   * @returns
   * tvhien 18.10.2022
   */
  async getDepartmentActive(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getDepartmentActive',
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Thêm mới tài khoản khi active trên grid
   * NTLOC 10/01/2023
   */
  getNewData(payload) {
    let request = {
      url: this.getAPIUrl() + '/newData',
      data: payload,
    };

    return httpClient.getAsync(request);
  }
}

export default new DepartmentAPI();
